<div class="content-container" role="main" [attr.aria-busy]="!ticket ? 'true' : 'false'" aria-live="assertive">
  @if (mainTheme !== themeType.Custom) {
    <id-card>
      <ng-container *ngTemplateOutlet="sithsEidAuthenticationContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="sithsEidAuthenticationContent"></ng-container>
    </div>
  }

  <ng-template #sithsEidAuthenticationContent>
    <div class="flex flex-column flex-align-center">
      <img class="icon" src="assets/images/siths-eid-icon.svg" alt="SITHS eID ikon" />

      <h1 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }} ids-mt-5">
        {{ getTypeText() }}
      </h1>
      <h2 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mb-5">
        {{ clientInfo?.organizationName }}
      </h2>

      @if (!pending) {
        <h3 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }}">Starta appen</h3>

        @if (!ticket) {
          <app-loading-spinner></app-loading-spinner>
        }

        @if (ticket) {
          <div class="panel-content flex flex-align-center flex-column ids-mb-3">
            @if (isSameDevice) {
              <div class="instructions-text-container">
                @if (!isAndroid || (isAndroid && !isSingleMethod())) {
                  <p class="instructions-text">Applikationen SITHS eID startas på din enhet.</p>
                }

                @if (isAndroid && isSingleMethod()) {
                  <p class="instructions-text">
                    <strong> Tryck på knappen nedan för att starta SITHS eID på denna enhet. </strong>
                  </p>
                }

                <p class="instructions-text">
                  Följ instruktionerna i appen för att slutföra {{ getMethodTypeText() }}.
                </p>
              </div>
            } @else {
              <div class="instructions-text-container">
                <p class="instructions-text">
                  Starta appen SITHS eID på din mobil eller surfplatta för att skanna QR-koden.
                </p>
              </div>

              @if (displayQrCode) {
                <div class="flex flex-column align-item-center">
                  <img [src]="base64Prefix + qrTokenB64" alt="QR-kod" />
                </div>
              }
            }

            <div class="ids-mt-5">
              @if (!isStarting) {
                <id-link>
                  <a href="javascript:void(0);" (click)="manualAutostart()">Starta SITHS eID på denna enhet</a>
                </id-link>
              } @else {
                <div class="ids-my-3"><app-loading-spinner></app-loading-spinner></div>
              }
            </div>

            <div class="ids-mt-3">
              <id-link>
                <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
              </id-link>
            </div>
          </div>
        }
      }

      @if (pending) {
        <h3 class="ids-heading-l ids-mb-5">Slutför {{ getMethodTypeText() }}</h3>

        <div class="panel-content">
          <div class="instructions-text-container">
            <p class="instructions-text">
              Följ anvisningar i SITHS eID applikationen för att slutföra {{ getMethodTypeText() }}.
            </p>
          </div>

          <div class="margin-50 flex flex-column align-items-center">
            <app-loading-spinner></app-loading-spinner>

            <div class="ids-mt-5">
              <id-link>
                <a href="javascript:void(0);" (click)="cancelAuthentication()">Avbryt {{ getMethodTypeText() }}</a>
              </id-link>
            </div>
          </div>
        </div>
      }
    </div></ng-template
  >
</div>
